export default __webpack_public_path__ + "static/media/proffessional.dccc9684.svg";